import React, { useContext } from 'react';
import PrintButton from '../PrintButton';
import MoreMenu from '../MoreMenu';
import OwnerControls from '../OwnerControls';
import { MatureContext } from '../../../Context';
import { useDeviationAttributes } from '../hooks/useDeviationAttributes';
export var PrimaryExtraActionBarIcons = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, printButtonClassName = _a.printButtonClassName, iconClassName = _a.iconClassName;
    var _b = useDeviationAttributes(deviation, isOwner), isReportable = _b.isReportable, isPrintPurchasable = _b.isPrintPurchasable, isEditable = _b.isEditable;
    var showMatureContent = useContext(MatureContext);
    return (React.createElement(React.Fragment, null,
        isReportable && (React.createElement(MoreMenu, { deviation: deviation, className: iconClassName })),
        (!deviation.isMature || showMatureContent) && isPrintPurchasable && (React.createElement(PrintButton, { deviation: deviation, className: printButtonClassName })),
        isEditable && (React.createElement(OwnerControls, { deviation: deviation, iconClassName: iconClassName }))));
};
PrimaryExtraActionBarIcons.displayName = 'PrimaryExtraActionBarIcons';
export default PrimaryExtraActionBarIcons;
//# sourceMappingURL=PrimaryExtraActionBarIcons.js.map